import React from 'react';
import { Redirect } from 'react-router-dom';

class URLOpen extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      urlList: ['']
    }
  }

  componentDidMount() {
    const { id } = this.props.match.params

    fetch(`https://mergeurl1.azurewebsites.net/v1/${id}`, {
      method: 'GET',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      redirect: 'follow',
      referrerPolicy: 'no-referrer'
    })
    .then(response => response.json())
    .then(response => {
      this.setState({
        urlList: response
      })
      var popup;
      if (this.state.urlList.length > 1) {
        alert("If your Popup Blocker is enabled, add this site to the exception list for opening multiple secure links seamlessly.");
      }
      if (this.state.urlList !== "Failed") {
        if (this.state.urlList[0].substring(0, 8) === "https://" || this.state.urlList[0].substring(0, 7) === "http://") {
          popup = window.open(`${this.state.urlList[0]}`, "_self");
        } else { 
          popup = window.open(`http://${this.state.urlList[0]}`, "_self"); 
        }
        if (this.state.urlList[1].substring(0, 8) === "https://" || this.state.urlList[1].substring(0, 7) === "http://") {
          popup = window.open(`${this.state.urlList[1]}`, "_blank");
        } else { 
          popup = window.open(`http://${this.state.urlList[1]}`, "_blank"); 
        }
        setTimeout(function() {
          if (!popup || popup.outerHeight === 0)
          alert("Popup Blocker is enabled. Add this site to the exception list for opening multiple secure links seamlessly.");
        }, 1000);
        for (let i = 2; i < this.state.urlList.length; i++) {
          if (this.state.urlList[i].substring(0, 8) === "https://" || this.state.urlList[i].substring(0, 7) === "http://") {
            popup = window.open(`${this.state.urlList[i]}`, "_blank");
          } else {
            popup = window.open(`https://${this.state.urlList[i]}`, "_blank");
          }
        }
      }
    });
  }

  render() {
    if (this.state.urlList === "Failed") {
      return (
        <Redirect to="/*" />
      )
    }
    return (
      <div></div>
    )
  }
}

export default URLOpen;
